"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserAvatar = UserAvatar;
exports.ImgAvatar = ImgAvatar;
exports.SimpleAvatar = SimpleAvatar;
exports.PinpointAvatar = PinpointAvatar;

var React = _interopRequireWildcard(require("react"));

var _index = require("../../index");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactAwesomeGravatar = require("react-awesome-gravatar");

var _lodash = require("lodash");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * This layers the Simple and Img avatars on top of one another.
 * If the Img Avatar cannot be displayed then it falls back to the Simple Avatar.
 */


function UserAvatar(_ref) {
  var pinpointFallback = _ref.pinpointFallback,
      user = _ref.user,
      sizeProps = _objectWithoutProperties(_ref, ["pinpointFallback", "user"]);

  var options = {
    size: 80,
    default: 'blank'
  };
  var profileUrl = (0, _reactAwesomeGravatar.getGravatarUrl)(user.email, options);
  var initials = [user.firstName, user.lastName].map(function (word) {
    return (0, _lodash.capitalize)(word[0]);
  }).join(' ');
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    },
    className: avatarClasses(_objectSpread({}, sizeProps))
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      zIndex: 1
    }
  }, pinpointFallback ? /*#__PURE__*/React.createElement(PinpointAvatar, sizeProps) : /*#__PURE__*/React.createElement(SimpleAvatar, _extends({
    initials: initials
  }, sizeProps))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      zIndex: 2
    }
  }, /*#__PURE__*/React.createElement(ImgAvatar, _extends({
    src: profileUrl
  }, sizeProps))));
}
/**
 * Some companies might block Gravatar images as they might be R-rated (apparently)
 * If the image doesn't load then ensure that we hide it
 */


function ImgAvatar(_ref2) {
  var src = _ref2.src,
      sizeProps = _objectWithoutProperties(_ref2, ["src"]);

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isVisible = _React$useState2[0],
      setIsVisible = _React$useState2[1];

  function handleError() {
    setIsVisible(false);
  }

  var styles = isVisible ? {} : {
    display: 'none'
  };
  return /*#__PURE__*/React.createElement("img", {
    className: avatarClasses(_objectSpread({}, sizeProps)),
    src: src,
    alt: "Avatar",
    onError: handleError,
    style: styles
  });
}

function SimpleAvatar(_ref3) {
  var initials = _ref3.initials,
      sizeProps = _objectWithoutProperties(_ref3, ["initials"]);

  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: avatarClasses(_objectSpread({}, sizeProps)),
    viewBox: "0 0 40 40",
    version: "1.1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20",
    fill: _index.Colors.SAGE_50
  }), /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "50%",
    textAnchor: "middle",
    fill: "white",
    className: _index.Classes.SUBHEADING1,
    style: {
      letterSpacing: '0'
    },
    dy: "0.3em",
    letterSpacing: "0"
  }, initials)));
}

function PinpointAvatar(_ref4) {
  var sizeProps = _extends({}, _ref4);

  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: avatarClasses(_objectSpread({}, sizeProps)),
    viewBox: "-33 -33 110 110"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "22",
    cy: "22",
    r: "55",
    fill: _index.Colors.IVORY_10
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EC9D84",
    d: "M0 0v22L22 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE554D",
    d: "M0 22v22l22-22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8B343",
    d: "M0 0H22v22h11c6.077 0 11-4.926 11-11 0-6.076-4.923-11-11-11"
  })));
}

function avatarClasses(_ref5) {
  var large = _ref5.large,
      small = _ref5.small;
  return (0, _classnames.default)(_defineProperty({}, _index.Classes.LARGE, large), _defineProperty({}, _index.Classes.SMALL, small), _index.Classes.AVATAR);
}